import { createReducer, on } from '@ngrx/store';

import * as ProprietaryFertilizerActions from './proprietary-fertilizer.actions';
import { ProprietaryFertilizerState } from '../models/proprietary-fertilizer.state.model';

export const proprietaryFertilizerReducer = createReducer<ProprietaryFertilizerState>(
  {},
  on(ProprietaryFertilizerActions.setOriginalCropAids, (state, { cropAids }) => ({
    ...state,
    originalCropAids: cropAids,
  })),
  on(
    ProprietaryFertilizerActions.setProprietaryFertilizers,
    (state, { proprietaryFertilizers }) => ({
      ...state,
      proprietaryFertilizers,
    }),
  ),
);
